export default __webpack_public_path__ + "static/media/bear-yellow.a3710889.svg";